import React, { useCallback, useEffect } from 'react';
import styled from 'styled-components';

import useTimer, { TimerState } from 'hooks/useTimer';
import GenericText from 'components/GenericText/GenericText';

const formatTime = ({ mins, secs }: { mins: number; secs: number }) => {
  const formattedSecs = secs.toString().length > 1 ? secs : `0${secs}`;
  const formattedMins = mins.toString().length > 1 ? mins : `0${mins}`;

  return `${formattedMins}:${formattedSecs}`;
};

const ReloadButton = styled.button`
  line-height: 1.3;
  color: ${({ theme, disabled }) =>
    disabled ? theme.colors.textLight : theme.colors.fountainBlue};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

const Time = styled.span`
  line-height: 1.3;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textDark};
`;

interface Props {
  onClick: () => Promise<unknown>;
}
function ResendButtonWithTimer({ onClick }: Props) {
  const { start, timerState, time } = useTimer({ minutes: 0, seconds: 30 });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(start, []);

  const handleClick = useCallback(
    event => {
      event.preventDefault();
      onClick().then(start);
    },
    [start, onClick]
  );

  return (
    <GenericText isTextMedium hasMarginTopSm hasMarginBottomSm>
      <span>Didn&apos;t get the OTP?</span>
      <ReloadButton disabled={timerState === TimerState.RUNNING} onClick={handleClick}>
        {timerState !== TimerState.RUNNING && `RESEND OTP`}
        {timerState === TimerState.RUNNING && (
          <span>
            Resend in <Time>{formatTime(time)}</Time>
          </span>
        )}
      </ReloadButton>
    </GenericText>
  );
}

export default ResendButtonWithTimer;
